/* global angular */
( function () {
	'use strict';

	function OpenEnded ( logger, deepLoadingStatusService, $modal, TOOLTIP_MESSAGES, _, $timeout ) {
		var self = this;

		function activate () {
			deepLoadingStatusService.decrementLoading( null, 'indicator' );

			$timeout( function () {
				if ( self.model.answerText ) {
					self.model.answerText = _.unescape( self.model.answerText );
				}
			} );
		}

		function openConfirmModal () {
			$modal.open( {
				'templateUrl'  : '/templates/components/indicators/score-validation/score-validation-modal.html',
				'controller'   : 'ScoreValidationCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'backdrop'     : 'static',
				'resolve'      : {
					'model' : function () {
						return self.model;
					},

					'groupModel' : function () {
						return self.groupModel;
					},

					'templateModel' : function () {
						return self.templateModel;
					},

					'templateLevel' : function () {
						return self.templateLevel;
					}
				}
			} );
		}

		function isInFormula ( model, id ) {
			return ( model.formula || '' ).indexOf( id ) > -1;
		}

		function isInGroupFormula () {
			return isInFormula( self.groupModel, self.model.id );
		}

		function isInTemplateFormula () {
			return isInFormula( self.templateModel, self.groupModel.id );
		}

		function checkFormulaLevel () {
			if ( self.templateModel.formula && isInTemplateFormula() ) {
				self.templateLevel = true;
				openConfirmModal();
			} else if ( self.groupModel.formula && isInGroupFormula() ) {
				self.templateLevel = false;
				openConfirmModal();
			} else {
				delete self.model.score;
			}
		}

		function enableScore ( score ) {
			if ( score ) {
				self.model.score = 0;
			} else {
				checkFormulaLevel();
			}
		}

		function digitsOnly ( option, tempValue ) {
			delete option.score;

			if ( String( tempValue ).length >= 8 ) {
				self.model.tempValue = 0;
			}

			if ( !angular.isUndefined( tempValue ) && angular.isNumber( tempValue ) ) {
				option.score = tempValue;
			}
		}

		function getToolTipMessage ( tempValue ) {
			var message = TOOLTIP_MESSAGES.templateOpEndEnableScoreMsg;

			if ( tempValue ) {
				message = TOOLTIP_MESSAGES.templateOpEndDisableScoreMsg;
			}

			return message;
		}

		function checkInFormula () {
			return isInFormula( self.groupModel, self.model.id );
		}

		self.enableScore       = enableScore;
		self.tooltip           = TOOLTIP_MESSAGES;
		self.digitsOnly        = digitsOnly;
		self.getToolTipMessage = getToolTipMessage;
		self.checkInFormula    = checkInFormula;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'OpenEnded', OpenEnded );

	OpenEnded.$inject = [ 'logger', 'deepLoadingStatusService', '$modal', 'TOOLTIP_MESSAGES', '_', '$timeout' ];
} )( );
